import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const objectsTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-object-class-view-objects-tab" */ './ui'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
